// $t(goldenFlower.***)

// ↓ 规则集中区
const oRules = {
    rule01Title: {
        en: '1. Basic Rules',
        cn: '1.基础规则',
    },
    rule02Title: {
        en: '2. Introduction to card types',
        cn: '2.牌型介绍',
    },
    rule03Title: {
        en: '3. Card comparison rules',
        cn: '3.比牌规则',
    },
    rule04Title: {
        en: '4. Settlement rules',
        cn: '4.结算规则',
    },
    rule05Title: {
        en: '5. Rake rules',
        cn: '5.抽水规则',
    },
    // =================================================
    rule01_1: {
        en: 'Fried Golden Flower is played with 1 deck of cards (52 cards without jokers) and 2-5 people play simultaneously.',
        cn: '炸金花由1副牌（52张无大小王），2—5人同时进行游戏。',
    },
    rule01_2: {
        en: 'Starting situation: Each player automatically puts 1 ante bet on the table, and then the dealer starts to deal cards, with 3 cards per person.',
        cn: '开局情况：每名玩家自动将1份底注投到桌面，再从庄家开始发牌，每人3张牌。',
    },
    rule01_3: {
        en: 'Call Raise: Betting the same amount as the previous player is called a call. Betting a larger amount than the previous player is called a raise.',
        cn: '跟注加注：下注与上一个玩家相同的金额，为跟注。下注选择比上一个玩家更大的金额，为加注。',
    },
    rule01_4: {
        en: 'Follow to the end: After selecting, you will automatically call every time it is your turn in this round. You can click again to cancel the selection.',
        cn: '跟到底：选择后本局内每次轮到自己都将自动跟注，可再次点击取消选择。',
    },
    rule01_5: {
        en: 'Checking the cards: After checking the cards, calling, raising, and comparing cards all require double draws.',
        cn: '看牌：看牌后，跟注、加注、比牌都需要双倍筹码。',
    },
    rule01_6: {
        en: 'Checking the cards: After checking the cards, calling, raising, and comparing cards require double the chips.',
        cn: '比牌：第二轮开始，轮到玩家时，可以选择比牌。选择比牌时需要先投注1份跟注额，比牌时牌型及点数相同，主动发起比牌的玩家输。',
    },
    rule01_7: {
        en: 'All-in: Starting from the fourth round, if there are only two players in the game, they can choose to go all-in. If the cards are the same, the player who initiated the all-in loses. The maximum all-in limit = maximum bet amount * number of rounds remaining. If the player does not show his cards, the maximum all-in limit = maximum bet amount * number of rounds remaining / 2.',
        cn: '全押：第四轮开始，若只有2名玩家在进行游戏，可选择全押。当牌型相同时，发起全押的玩家输。全押上限=最大可下注额度*剩余轮数，如果玩家是没有亮牌，则全押上限=最大可下注额度*剩余轮数/2。',
    },
    rule01_8: {
        en: 'Discard: Players can voluntarily discard their cards, or automatically discard their cards when the timer expires.',
        cn: '弃牌：玩家可主动弃牌，或超时自动弃牌。',
    },
    rule01_9: {
        en: 'Last Bets: When a player runs out of gold to call a bet, they can choose to make a last bet and compare cards with all other players. If they win, the game ends; if they lose, the other players continue playing.',
        cn: '最后一搏：当玩家金币不足以进行跟注时，即可选择是否最后一搏，和所有玩家比牌。比牌获胜牌局结束；比牌失败，其他玩家继续游戏。',
    },
    rule01_10: {
        en: 'Final Draw: When the maximum number of rounds is reached, the system automatically compares all hands. The player with the highest hand wins and takes the total bet. If multiple players have the same highest hand, the coins are split equally.',
        cn: '终局开牌：当游戏轮数达到上限时，系统自动进行全场比牌。牌型大小最大的玩家为胜，独自获得全场总注。如果有多个玩家牌型相同且都是全场最大，则平分金币。',
    },
    rule02_column01A: {
        en: 'Card type',
        cn: '牌型',
    },
    rule02_column01B: {
        en: 'Three of a Kind',
        cn: '豹子',
    },
    rule02_column01C: {
        en: 'Straight Flush',
        cn: '顺金',
    },
    rule02_column01D: {
        en: 'Flush',
        cn: '金花',
    },
    rule02_column01E: {
        en: 'Straight',
        cn: '顺子',
    },
    rule02_column01F: {
        en: 'Pair',
        cn: '对子',
    },
    rule02_column01G: {
        en: 'High Card',
        cn: '单张',
    },
    rule02_column02A: {
        en: 'Explanation',
        cn: '说明',
    },
    rule02_column02B: {
        en: 'Three cards of the same rank.<br/>(AAA is the highest, 222 is the lowest.)',
        cn: '三张点数相同的牌。<br/>（AAA最大，222最小）',
    },
    rule02_column02C: {
        en: 'A straight of the same suit.<br/>(QKA is the highest, A23 is the lowest.)',
        cn: '花色相同的顺子。<br/>（QKA最大，A23最小）',
    },
    rule02_column02D: {
        en: 'Three cards of the same suit but not in sequence.<br/>(JKA is the highest, 235 is the lowest.)',
        cn: '花色相同的非顺子。<br/>（JKA最大，235最小）',
    },
    rule02_column02E: {
        en: 'A straight of mixed suits.<br/>(QKA is the highest, A23 is the lowest.)',
        cn: '花色不同的顺子。<br/>（QKA最大，A23最小）',
    },
    rule02_column02F: {
        en: 'A pair of cards with the same rank.<br/>(AAK is the highest, 223 is the lowest.)',
        cn: '两张点数相同的牌。<br/>（AAK最大，223最小）',
    },
    rule02_column02G: {
        en: 'Three cards that do not form any of the above hand types.<br/>(JKA is the highest, 235 is the lowest.)',
        cn: '三张牌不组成以上任意类型牌。<br/>（JKA最大，235最小）',
    },
    rule02_column03A: {
        en: 'Example',
        cn: '示例',
    },
    // ==============================================
    rule03_1: {
        en: 'Hand Rankings<br/>Three of a Kind > Straight Flush > Flush > Straight > Pair > High Card',
        cn: '牌型比较<br/>豹子>顺金>金花>顺子>对子>单张',
    },
    rule03_2: {
        en: 'Comparison within the same hand type<br/>A>K>Q>J>10>9>8>7>6>5>4>3>2',
        cn: '牌型相同比较牌数字大小<br/>A>K>Q>J>10>9>8>7>6>5>4>3>2',
    },
    rule03_3: {
        en: 'Ranking of Straight Flush and Straight<br/>QKA>JQK>10JQ>910J>8910>789>678>567>456>345>234>A23',
        cn: '顺金、顺子的大小排序为<br/>QKA>JQK>10JQ>910J>8910>789>678>567>456>345>234>A23',
    },
    rule04_1: {
        en: `Loss Points = The total bet of the player in the current round.<br/>Win Points = The total bets of all players in the current round.<br/>In case of a tie, the total bets of the round are split equally.`,
        cn: '输分=玩家自己本局全部投注额；<br/>赢分=当局全部玩家总投注额；<br/>平局则平分当局总投注额。',
    },
    rule05_1: {
        en: '{taxRate}% of the winner’s net profit.',
        cn: '抽取赢家净利润的 {taxRate}%。',
    },
};

// 按钮集中区
const oButton = {
    Change: {
        en: 'Change',
        cn: '换桌',
    },
    Reveal: {
        en: 'Reveal',
        cn: '亮牌',
    },
    ...{
        // 游戏中
        Fold: {
            en: 'Fold',
            cn: '弃牌',
        },
        CallOnce: {
            en: 'Call {val}',
            cn: '跟{val}',
        },
        CallAllTheway: {
            en: 'Call',
            cn: '跟到底',
        },
        CallLast: {
            en: 'Last Bet',
            cn: '最后一搏',
        },
        Match: {
            en: 'Match',
            cn: '比牌',
        },
        View: {
            en: 'View',
            cn: '看牌',
        },
        Viewed: {
            en: 'Viewed',
            cn: '已看牌',
        },
        Val: {
            en: '{val}',
            cn: '{val}',
        },
    },
    ...{
        // 加注按钮
        Raise: {
            en: 'Raise',
            cn: '加注',
        },
        AllIn: {
            en: 'All-in {val}',
            cn: '全押 {val}',
        },
        RaiseVal: {
            en: 'Raise {val}',
            cn: '加{val}',
        },
        Eliminate: {
            en: 'Eliminate',
            cn: '淘汰',
        },
    },
    Rematch: {
        en: 'Rematch',
        cn: '重新匹配',
    },
    Exit: {
        en: 'Exit Game',
        cn: '退出游戏',
    },
    Reselect: {
        en: 'Reselect',
        cn: '重新选择',
    },
};

const oStage = {
    ...oButton,
    dealer: {
        en: 'Dealer',
        cn: '荷官', //
    },
    empty: {
        // 玩家坐席为空
        en: 'Empty',
        cn: '暂无',
    },
    ready: {
        en: 'Starting Soon',
        cn: '游戏即将开始',
    },
    wait: {
        en: 'Waiting for other players',
        cn: '正在等待其他玩家',
    },
    waitnext: {
        en: 'Waiting for next round',
        cn: '请等待下一局',
    },
    banker: {
        en: 'B',
        cn: '庄',
    },
    turns: {
        en: 'Turns',
        cn: '轮数',
    },
    ante: {
        en: 'Ante',
        cn: '底注',
    },
    limit: {
        en: 'Betting Limit',
        cn: '单注上限',
    },
    changeRes: {
        en: 'Change the table successfully!',
        cn: '换桌成功！',
    },
    selectUser: {
        en: 'Select an opponentd',
        cn: '请选择比牌玩家',
    },
    finding: {
        en: 'Find player in {val}',
        cn: '{val}正在匹配玩家',
    },
    timeout: {
        en: 'Match Timeout',
        cn: '匹配超时',
    },
    noOpponent: {
        en: 'No opponent found in time',
        cn: '未能在规定时间内找到对手',
    },
    showdown: {
        en: 'Showdown cancelled',
        cn: '比牌已取消',
    },
    text1: {
        en: 'Player folded. Choose another',
        cn: '玩家已弃牌，请重新选择比牌对象',
    },
};

// 历史记录详情相关
const oHistoryAbout = {
    AsMuch20Records: {
        en: 'View up to {rows} records within {day} days',
        cn: '最多查看{day}日内{rows}条记录',
    },
    room: {
        en: 'Room',
        cn: '房间',
    },
    win: {
        en: 'Payout',
        cn: '输赢',
    },
    Profit: {
        en: 'Profit',
        cn: '收益',
    },
    result: {
        en: 'Result',
        cn: '结果',
    },
    winText: {
        en: 'Win',
        cn: '赢',
    },
    loseText: {
        en: 'Lose',
        cn: '输',
    },
    drawText: {
        en: 'Draw',
        cn: '平局',
    }
};

// 用于大厅列表 
const oHallList = {
    access: {
        en: 'Access',
        cn: '准入',
    },
    ante: {
        en: 'Ante',
        cn: '底注',
    },
    exitRoom: {
        en: 'Please log out of the room before changing the currency',
        cn: '请先退出房间再变更货币',
    },
};


// 一些弹出的提示信息 
const oToast = {
    lowBalance: {
        en: 'Insufficient balance, unable to enter this hall',
        cn: '余额不足，无法进入此厅',
    },
    hallDisabled: {
        en: 'Hall disabled',
        cn: '大厅已禁用',
    },
    noHall: {
        en: 'Hall does not exist or has been disabled',
        cn: '大厅不存在或已禁用',
    },
    onErr: {
        en: 'Failed to enter the game, please select again.',
        cn: '进入游戏失败，请重新选择',
    },
    gameRun: {
        en: "The game isn't over yet, don't rush to leave!",
        cn: '游戏还没结束，不要急着离开！',
    },
    gameReady: {
        en: "The game is about to begin, so don't rush to leave!",
        cn: '游戏即将开始，不要急着离开！',
    },
    notEnoughChips: {
        en: 'Insufficient balance!',
        cn: '余额不足!',
    },
    inactiveWarning: {
        en: 'You have been inactive for {val} consecutive rounds. If you remain inactive for 5 consecutive rounds, you will be removed from the room.',
        cn: '您已连续{val}局未进行操作，若连续5局未操作，将被请离房间。',
    },
    ended: {
        en: 'The game has ended',
        cn: '牌局已结束',
    },
    netError: {
        en: 'Network error',
        cn: '网络问题',
    },
    finalComp: {
        en: 'Final Showdown',
        cn: '终局比牌中',
    },
};

const oRoom = {
    novice: {
        en: 'NOVICE',
        cn: '体验厅',
    },
    leisure: {
        en: 'LEISURE',
        cn: '娱乐厅',
    },
    flagship: {
        en: 'FLAGSHIP',
        cn: '旗舰厅',
    },
    royal: {
        en: 'ROYAL',
        cn: '富豪厅',
    },
    supreme: {
        en: 'supreme',
        cn: '至尊厅',
    },
};

const notice = {
    in: {
        en: 'in',
        cn: '在',
    },
    winValue: {
        en: 'win {val}',
        cn: '赢得{val}',
    },
    amazing: {
        en: ',amazing!',
        cn: ',真是羡煞旁人!',
    },
    inRoom: {
        en: 'You are already at {val}. Please leave the table first!',
        cn: '您已在{val}牌桌内，请先退出牌桌!',
    },
};

export const oGoldenFlowerLang = {
    ...oStage,
    ...oRules,
    ...oHistoryAbout,
    ...oHallList,
    ...oToast,
    ...oRoom,
    ...notice
};
